module.exports = __webpack_public_path__ + "img/s-mob-3.518a81f8.webp";